// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1GXsK","header":"MessagesList_header__3yV1u","chat":"MessagesList_chat__2wv2D"};